import { IChatNewState } from './types'
import ChatRoom from '@/models-ts/chat/ChatRoom'
import LoadablePageMapModel from '@/models-ts/LoadablePageMapModel'

export const getInitialState = (): IChatNewState => ({
  connected: false,
  initialized: false,
  freelanceRooms: new LoadablePageMapModel(),
  vacanciesRooms: new LoadablePageMapModel(),
  archivedRooms: new LoadablePageMapModel(),
  lastFiltersReq: {
    freelance: null,
    vacancies: null,
    archived: null,
  },
  messages: {},
  openedRoomId: null,
  openedRooms: {},
  participants: {},
  unreadMap: {},
  search: '',
  lastSearch: '',
  clientId: null,
})

export const ROOM_STORAGE = ['freelanceRooms', 'vacanciesRooms', 'archivedRooms'] as const

export function getRoom(state: IChatNewState, roomId: ChatRoom['id']) {
  for (let roomStorage of ROOM_STORAGE) {
    const room = state[roomStorage].values[roomId]
    if (room) {
      return room
    }
  }
}
